import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class SettlementCheckOptionsModel extends BaseModel {
  static urlPath = "settlement_checks";

  @attr('json') actions;
  @attr('string') description;
  @attr('string') name;
  @attr('json') parses;
  @attr('json') renders;

  get checkTypeOptions() {
    return this.actions.POST.check_type.choices;
  }

  get paidOptions() {
    return this.actions.POST.paid_by.children.entity_type.choices;
  }
}
